import * as React from "react";
import { UitkHeading } from "uitk-react-text";

const CardTitle = ({ cardTitle }: { cardTitle: string }) => (
  <UitkHeading size={500} overflow="truncate" level={3}>
    {cardTitle}
  </UitkHeading>
);

export default CardTitle;
